import type { ISectionSettings } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'

import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'

import { IPartnerFlag } from '../model/IPartnerFlag'
import {
  MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX,
  MANDATORY_CATEGORY_VISIBLE_SUFFIX,
  OVERALL_CATEGORY_MANDATORY_FLAG,
  READONLY_FLAGS,
  TOP_PARTNER_FLAGS,
} from '../model/mandatoryFlags'

import { getPartnerFlagTag } from './getPartnerFlagTag'

export interface IMandatoryResult {
  isMandatory: boolean
  isSkipTransactional: boolean
}

export const isSubCategoryMandatory = (
  partnerFlags: string,
  settingFlags: string,
  sectionSettings: Partial<IClientSectionSettings> | Partial<ISectionSettings>,
  isSkipOverall: boolean
): IMandatoryResult => {
  const partnerFlagsNames = (partnerFlags || '').split(',')
  const partnerFlagsState: IPartnerFlag[] = []

  const settingFlagsNames = (settingFlags || '').split(',')
  settingFlagsNames
    .filter((el) => !!el)
    .forEach((settingFlag) => {
      let isVisible = true
      let isSkipTransactional = false

      if (!!settingFlag && settingFlag.endsWith(MANDATORY_CATEGORY_VISIBLE_SUFFIX)) {
        settingFlag = settingFlag.substring(0, settingFlag.length - 1)
        isVisible = false
      }
      if (!!settingFlag && settingFlag.endsWith(MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX)) {
        settingFlag = settingFlag.substring(0, settingFlag.length - 1)
        isSkipTransactional = true
      }

      const tag = getPartnerFlagTag(settingFlag)

      if (settingFlag === OVERALL_CATEGORY_MANDATORY_FLAG) {
        if (!isSkipOverall) {
          partnerFlagsState.push({
            name: settingFlag,
            tag,
            isPartnerFlag: false,
            isReadonly: false,
            isTopPartner: false,
            isEnabled: true,
            isVisible,
            isSkipTransactional,

            disablingUser: '',
            disablingDate: '',
            disablingComment: '',
          })
        }
      } else {
        const foundFlags = partnerFlagsState.filter((el) => el.name === settingFlag)
        if (!foundFlags.length) {
          const isPartnerFlag = partnerFlagsNames.includes(settingFlag)
          const isReadonly = READONLY_FLAGS.indexOf(settingFlag) >= 0
          const isTopPartner = TOP_PARTNER_FLAGS.indexOf(settingFlag) >= 0

          // Use manually flag override only if flag not set on Partner level
          const flagFromSettings = sectionSettings[tag]

          // Get Flag state from settings (if settings exist)
          let isSettingPresent = false
          let isFlagManuallyEnabled = false
          if (flagFromSettings !== undefined && flagFromSettings !== null) {
            isSettingPresent = true
            isFlagManuallyEnabled = isSectionSettingOn(flagFromSettings)
          }

          // Flags enabled by default for TopPartners and PartnerFlags (if no settings)
          const isForceEnabled = isPartnerFlag && (isTopPartner || !isSettingPresent)
          const isFlagEnabled = isForceEnabled ? true : isFlagManuallyEnabled

          // Force visibility for Partner level flag
          if (isPartnerFlag) {
            isVisible = true
          }

          const disablingUser = sectionSettings[`${tag}-user`]
          const disablingDate = sectionSettings[`${tag}-date`]
          const disablingComment = sectionSettings[`${tag}-comment`]

          partnerFlagsState.push({
            name: settingFlag,
            tag,
            isPartnerFlag,
            isReadonly,
            isTopPartner,
            isEnabled: isFlagEnabled,
            isVisible,
            isSkipTransactional,

            disablingUser,
            disablingDate,
            disablingComment,
          })
        }
      }
    })

  return {
    isMandatory: partnerFlagsState.some((el) => el.isEnabled),
    isSkipTransactional: partnerFlagsState.some((el) => el.isEnabled && el.isSkipTransactional),
  }
}
